/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const bulkGetItemFinancialsRequestSchema = z.object({
  itemIds: z.array(z.int()),
});
